import React, { useContext, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import CustomInput from '~/components/CustomInput'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { FeedPageContext } from '../..'
import notify from '~/components/Notify'

interface Props {
  barleyData: Nullable<{ index: number, key: string, feedName: string }>
  handleClose: () => void
}

const BarleyModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { getValues, setValue } = useFormContext()
  const { setEnergyCalcData } = useContext(FeedPageContext)

  const { barleyData, handleClose } = props
  const [barleyValues, setBarleyValues] = useState({
    dryMatter: '',
    energy: ''
  })

  useEffect(() => {
    if (barleyData) {
      const barleyValue = getValues(`${barleyData?.key}[${barleyData.index}]`)
      setBarleyValues({
        dryMatter: barleyValue?.dryMatter,
        energy: barleyValue?.energy
      })
    }
  }, [barleyData])

  function handleSubmit() {
    const barleyValue = getValues(`${barleyData?.key}[${barleyData.index}]`)
    setValue(`${barleyData?.key}[${barleyData.index}]`, { ...barleyValue, ...barleyValues })
    setBarleyValues({
      dryMatter: '',
      energy: ''
    })
    notify(t('The content values for {{feedName}} have been successfully adjusted.', { feedName: barleyData?.feedName || '' }), 'success')
    setEnergyCalcData(null)
    handleClose()
  }

  function renderBarleyValues() {
    return <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
      <CustomInput
        value={barleyValues?.dryMatter}
        label={t('TM')}
        placeholder={t('TM')}
        decimalScale={2}
        suffix={' %'}
        withLabels
        allowDecimals={true}
        onChange={(value) => setBarleyValues({ ...barleyValues, dryMatter: value as string || '' })}
      />
      <CustomInput
        value={barleyValues?.energy}
        label={t('Energy')}
        decimalScale={2}
        withLabels
        suffix={' NJ NEL/kg TM'}
        allowDecimals={true}
        placeholder={t('Energy')}
        onChange={(value) => setBarleyValues({ ...barleyValues, energy: value as string || '' })}
      />
    </div>
  }

  return <Dialog
    textHeader={t('Edit barley for {{feedName}}', { feedName: barleyData?.feedName || '' })}
    textClose={t('Cancel')}
    type='abort'
    textSubmit={t('Adjust')}
    disableSubmit={barleyValues?.dryMatter === '' || barleyValues?.energy === ''}
    isDialogOpen={Boolean(barleyData)}
    handleClose={() => handleClose()}
    handleSubmit={() => handleSubmit()}
    textContent={renderBarleyValues()}
  />
}
export default BarleyModal